import {
  useState,
  useRef,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";

import {
  Box,
  Stack,
  TextField,
  Button,
  IconButton,
  Tooltip,
} from "@mui/material";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import ContentPasteGoIcon from "@mui/icons-material/ContentPasteGo";
import RefreshIcon from "@mui/icons-material/Refresh";
import BorderColorIcon from "@mui/icons-material/BorderColor";

import { userState } from "../../../interface/MainInterface";

import { CommonUtils } from "../../../utils/common_utils";

import LoadingCircle from "../../../utils/LoadingCircle";
import Toast from "../../../utils/Toast";

import PopThemeSelect from "../../theme/PopThemeSelect";

const testData: any = {
  주관부서: "현대홈쇼핑 마케팅팀",
  관계자: "조일연 선임",
  행사명: "슈퍼H페스타",
  행사장소: "현대홈쇼핑 공식 온라인몰 '현대H몰'",
  행사일자: "2023년 10월 5일 ~ 2023년 10월 31일",
  행사배경: "가을 겨울 상품 고객 수요 선점",
  타깃: "30~40대 여성",
  제공혜택:
    "①10/5~10일 '혜택집중기간' 운영. 이 기간 하루 선착순 5만명씩 총 200억원 상당의 할인쿠폰 제공하고 상품 구매 고객에게 결제 금액의 10%를 H포인트 리워드\n② 할인쿠폰 및 적립혜택 역대 최대로 마련(10월 둘째주부터 매주 금요일~일요일에 하루 선착순 5만명을 대상으로 할인쿠폰 최대 1만 5000원 증정)\n③0월 31일까지 결제 횟수가 3회 이상이면서 구매금액이 40만원 이상인 고객들에게 미니 압력밥솥 또는 스테인리스 김치통 사은품 증정하고 결제 횟수 5회 이상 및 구매금액 40만원 이상 고객은 H포인트 2만포인트 추가 지급",
  "관계자 멘트":
    "역대 최대 규모의 할인 혜택을 제공하는 행사로, 가을 겨울 상품을 합리적인 가격에 구매할 수 있는 좋은 쇼핑 기회다.",
};

const testData2: any = {
  "채결 일자": "2023년 12월 14일",
  "체결 장소": "용인시 수지구 현대그린푸드 본사 사옥",
  "참석자(양사)":
    "이헌상 현대그린푸드 상품본부장 부사장, 민경천 한우자조금관리위원장 등 양사 주요 관계자",
  "체결 목적":
    "한우 가격이 지속 하락하는 등 한우농가가 어려움을 겪는 상황에서, 현대그린푸드가 가지고 있는 다양한 유통망을 활용해 한우 소비를 확대하겠다는 취지의 내용",
  "MOU 내용":
    "현대그린푸드는 한우 정육을 매입해 물량 해소에 기여하고, 한우자조금 측은 현대그린푸드가 매입하는 수입육을 한우로 대체하기 위해 예산을 지원한다는 내용",
  기대성과:
    "- 한우 소비 확대\n- 현대그린푸드가 운영하는 단체급식 사업장에 한우를 활용한 특식 메뉴 개발\n- 현대그린푸드의 건강식 브랜드 ‘그리팅’의 경우에도, 한우를 활용한 신상품 출시\n- 현대백화점 식품관에서 한우 판매 촉진을 위한 프로모션을 검토",
  "회사 멘트":
    "이번 MOU를 통해 한우농가의 어려움을 해결하고, 소비자들에게도 질 좋은 한우를 제공할 수 있게 됐다는 내용과 앞으로도 여러 분야에서 협력을 이어갈 것이라는 취지의 이헌상 현대그린푸드 상품본부장(부사장)의 멘트",
};

const testResult =
  "1. 주 제목 : 현대백화점, 슈퍼H페스타 개최로 가을 겨울 상품 합리적인 가격에 구매할 수 있는 기회 제공\n\n2. 부 제목 : 역대 최대 규모의 할인 혜택과 다양한 이벤트로 소비자 만족도 높여\n\n3. 리드문 (육하원칙) : 현대백화점은 2023년 10월 5일부터 31일까지 현대홈쇼핑 공식 온라인몰 '현대H몰'에서 슈퍼H페스타를 개최합니다. 이번 행사는 가을 겨울 상품을 합리적인 가격에 구매할 수 있는 역대 최대 규모의 할인 혜택과 다양한 이벤트를 제공하여 소비자 만족도를 높이고자 합니다.\n\n4. 본문 : 현대백화점은 가을 겨울 시즌을 맞아 고객들의 상품 수요를 선점하기 위해 슈퍼H페스타를 개최합니다. 이번 행사는 현대홈쇼핑과 협력하여 현대H몰에서 진행됩니다. 슈퍼H페스타는 2023년 10월 5일부터 31일까지 4주 동안 진행됩니다.\n\n이번 행사에서는 타깃 고객인 30~40대 여성을 위해 다양한 제공혜택을 제공합니다. 가장 큰 혜택은 10월 5일부터 10일까지의 '혜택 집중 기간'에서 이루어집니다. 이 기간 동안, 매일 선착순 5만명에게 총 200억원 상당의 할인쿠폰을 제공하고, 상품을 구매한 고객에게는 결제 금액의 10%에 해당하는 H포인트를 리워드로 지급합니다.\n\n또한, 할인쿠폰 및 적립혜택도 역대 최대로 마련되었습니다. 10월 둘째주부터 매주 금요일부터 일요일까지 선착순 5만명을 대상으로 할인쿠폰을 최대 1만 5000원까지 증정합니다. 이를 통해 고객들은 더욱 알찬 혜택을 받으며 상품을 구매할 수 있습니다.\n\n마지막으로, 10월 31일까지 결제 횟수가 3회 이상이면서 구매금액이 40만원 이상인 고객들에게는 미니 압력밥솥 또는 스테인리스 김치통을 사은품으로 증정합니다. 또한, 결제 횟수가 5회 이상이면서 구매금액이 40만원 이상인 고객들에게는 H포인트 2만포인트를 추가로 지급하여 더 많은 혜택을 제공합니다.\n\n조일연 선임은 \"역대 최대 규모의 할인 혜택을 제공하는 슈퍼H페스타로, 가을 겨울 상품을 합리적인 가격에 구매할 수 있는 좋은 쇼핑 기회를 제공하고자 합니다\"라고 말했습니다.\n\n5. 인용문 : \"역대 최대 규모의 할인 혜택을 제공하는 슈퍼H페스타로, 가을 겨울 상품을 합리적인 가격에 구매할 수 있는 좋은 쇼핑 기회를 제공하고자 합니다.\" - 조일연 선임";

const defaultOneShot =
  " 참고자료 : \n" +
  " - 회사명 : 현대백화점\n" +
  " - 배포 희망일 : 2024년 1월 11일\n" +
  " - 홍보 취지 : 현대백화점 압구정본점 식품관 리뉴얼 통한 프리미엄 이미지 업그레이드\n" +
  " - 백화점 점포명 : 압구정본점\n" +
  " - 리뉴얼 오픈일 : 2024년 1월 12일\n" +
  " - 리뉴얼 위치(층) : 지하 1층 식품관\n" +
  " - 리뉴얼 콘셉트 : 기존 백화점 푸드코트를 한 단계 업그레이드 한 신개념 미식 공간 ‘프리미엄 다이닝 홀‘ 가스트로 테이블(Gastro Table)\n" +
  " - 리뉴얼 특징 : 1. 18년 만의 식품관 전면 리뉴얼\n2. 5개월 동안 리뉴얼 진행\n3. 2년 여 간 준비한 프로젝트\n4. 국내 유명 공간 디자이너들의 컨설팅을 기반으로 완성도 높은 공간 디자인 구현\n" +
  " - 총 브랜드 수 : 28개 미식 브랜드\n" +
  " - 리뉴얼 네이밍 : ‘미식(Gastronomy)’과 ‘다이닝 공간(Table)’의 합성어인 가스트로 테이블(Gastro Table)\n" +
  " - 신규 입점 브랜드 : 1. 유명 셰프와 레스토랑이 압구정본점에 처음으로 론칭한 미식 브랜드 8개\n- 인기 한우 오마카세 ‘이속우화’의 철판요리 전문점 ‘우화함’\n- 2023 미슐랭 가이드 선정 ‘산다이’ 문승주 셰프의 일식 브랜드 ‘마키 산다이’\n- 정호영 셰프의 샤브샤브․스키야키 전문점 ‘샤브카덴’\n- 중식 파인다이닝 JS가든의 중식 전문점 ‘슈슈차이’\n- ‘수퍼판’ 우정욱 오너 셰프의 프리미엄 분식 브랜드 ‘가지가지‘\n2. 최초 입점하는 국내 유명 맛집 브랜드\n- 미슐랭 레스토랑 ‘모수’ 안성재 셰프, ‘소설한남’ 엄태철 셰프, ‘주옥’ 신창옥 셰프 등이 협업해 론칭한 글로벌 퀴진 브랜드 ‘핸디드 레시피 서울’\n- 압구정 프리미엄 퓨전 한식 ‘도슬박’ 등\n3. 백화점 최초 입점 국내외 디저트 브랜드\n- 잠실 석촌호수 미트파이 맛집 ‘진저베어’\n- 일본 도쿄에서 생카라멜 쉬폰케이크로 유명한 ‘마사비스(MERCER bis)’ 국내 1호점\n" +
  " - 인테리어 특징 : 1. 가스트로 테이블의 공간 디자인은 일본 신주쿠역사 인테리어 등을 담당했던 일본 건축사무소 시나토(Sinato)가 담당\n2. 인스타그래머블(instagramable․인스타그램에 올릴 만한)한 공간 디자인\n3. 외부 정원같은 느낌을 살리기 위해 밝은 조명과 화이트 톤의 노출 천장으로 공간감 극대화\n4. 자연 속에서 식사하는 듯한 느낌을 전달하기 위해 매장 곳곳에 대형 식재와 가드닝 인테리어 적용\n" +
  " - 관계자 멘트 : 새롭고 고급스러운 미식 문화를 추구하는 고객들의 기대에 부응하기 위해 노력하겠다는 취지의 류영민 현대백화점 압구정본점장 상무의 멘트\n" +
  " - 차별화 서비스 : 1. 기존 백화점 푸드코트에서는 볼 수 없던 고급 레스토랑급 서비스 도입\n- 기존 푸드코트의 ‘셀프픽업‘이 아닌 주문한 음식을 고객에게 직접 서빙\n- 휴대폰으로 메뉴 확인 및 주문, 계산까지 가능한 ‘테이블 오더 서비스‘. 고객이 앉은 자리에서 주문과 계산을 한 번에 해결할 수 있는 서비스로 고객 스마트폰으로 테이블에 비치된 QR코드를 스캔하면 이용 할 수 있음\n\n" +
  " \n\n" +
  "1. 주 제목\n" +
  "  1) 현대백화점, 압구정본점에 신개념 프리미엄 다이닝 홀 선보인다\n" +
  "  2) 현대백화점 압구정본점 새로운 미식 공간으로 변신 ‘미식 끝판왕 도전‘\n\n" +
  "2. 부 제목\n" +
  "  1) 압구정본점 식품관, 18년 만에 전면 리뉴얼\n" +
  "  2) 국내외 유명 맛집∙디저트 브랜드 28개 입점\n" +
  "  3) 차별화된 최고급 미식 콘텐츠와 차별화된 서비스 제공\n" +
  "  4) “백화점 식품관 품격 한 단계 높일 것”\n\n" +
  "3. 리드문\n" +
  "  현대백화점이 압구정본점 식품관을 전면 리뉴얼해 프리미엄 이미지를 업그레이드한다. 국내 최정상급 미식 콘텐츠와 고급 레스토랑급 서비스를 앞세워 압구정본점만의 ‘미식 초격차’를 이어나가겠다는 구상이다.\n\n" +
  "4. 본문\n" +
  "  현대백화점은 5개월 간 리뉴얼 공사를 마치고 압구정본점 지하1층 식품관 내 신개념 프리미엄 다이닝 홀 ‘가스트로 테이블(Gastro Table)’을 오픈한다고 4일 밝혔다. 현대백화점이 압구정본점 식품관을 전면 리뉴얼 한 건 18년 만이다. 가스트로 테이블은 ‘미식(Gastronomy)’과 ‘다이닝 공간(Table)’의 합성어다.\n\n" +
  "  이번 식품관 리뉴얼은 압구정본점의 프리미엄 이미지를 높이기 위해 2년 여 동안 준비된 프로젝트로 내 유명 공간 디자이너들의 컨설팅을 받아 완성도 높은 공간 디자인을 구현했다. \n\n" +
  "  이번에 문을 연 가스트로 테이블에는 유명 셰프들이 새롭게 개발한 레스토랑과 국내외 유명 디저트 브랜드 등 총 28개 미식 브랜드가 들어선다. 우선, 현대백화점은 유명 셰프와 레스토랑이 압구정본점에 처음으로 론칭한 미식 브랜드 8개를 선보인다. 대표 레스토랑으로는 인기 한우 오마카세 ‘이속우화’의 철판요리 전문점 ‘우화함’, 2023 미슐랭 가이드 선정 ‘산다이’ 문승주 셰프의 일식 브랜드 ‘마키 산다이’, 정호영 셰프의 샤브샤브․스키야키 전문점 ‘샤브카덴’, 중식 파인다이닝 JS가든의 중식 전문점 ‘슈슈차이’, ‘수퍼판’ 우정욱 오너 셰프의 프리미엄 분식 브랜드 ‘가지가지’ 등이 있다.\n\n" +
  "  국내 유명 맛집 브랜드들도 가스트로 테이블에 처음 입점시켰다. 대표 유명 맛집 브랜드로는 미슐랭 레스토랑 ‘모수’ 안성재 셰프·‘소설한남’ 엄태철 셰프·‘주옥’ 신창옥 셰프 등이 협업해 론칭한 글로벌 퀴진 브랜드 ‘핸디드 레시피 서울’, 압구정 프리미엄 퓨전 한식 ‘도슬박’ 등이 있다.\n\n" +
  "  백화점에 입점하지 않았던 국내외 유명 디저트 브랜드도 압구정본점에 선보인다. 잠실 석촌호수 미트파이 맛집 ‘진저베어’와 일본 도쿄에서 생카라멜 쉬폰케이크로 유명한 ‘마사비스(MERCER bis)’ 국내 1호점 등이 대표적이다.\n\n" +
  "  또한, 압구정본점 식품관은 인테리어적으로도 주목할 만한 특징을 갖고 있다. 일본 신주쿠역사 인테리어 등을 담당한 일본 건축사무소 시나토(Sinato)가 가스트로 테이블의 공간 디자인을 담당하여 인스타그래머블한 공간을 구현해냈다. 밝은 조명과 화이트 톤의 노출 천장으로 공간감을 극대화하고, 대형 식재와 가드닝 인테리어를 활용하여 외부 정원과 같은 느낌을 전달한다.\n\n" +
  "  그동안 백화점 푸드코트에서는 볼 수 없던 고급 레스토랑급 서비스도 가스트로 테이블의 강점이다. 기존 푸드코트의 ‘셀프픽업’과 달리 고객이 주문한 음식을 자리까지 직원이 직접 서빙해 준다. 또한, 고객 편의를 위해 테이블에서 휴대폰으로 메뉴 확인은 물론 주문 및 계산까지 원스톱으로 해결할 수 있는 ‘테이블 오더 서비스’도 운영한다. 고객이 앉은 자리에서 주문과 계산을 한 번에 해결할 수 있는 서비스로, 고객 스마트폰으로 테이블에 비치된 QR코드를 스캔하면 이용 가능하다.\n\n" +
  "5. 인용문\n" +
  "  회사 관계자는 ‘국내 어디에서도 경험할 수 없는 최고의 미식 MD 구성을 통해 백화점 식품관의 품격을 한 단계 높일 것‘이라며 ‘앞으로도 새롭고 고급스러운 미식 문화를 추구하는 고객들의 기대에 부응하기 위해 최선을 다할 방침‘이라고 말했다.\n\n" +
  "--------------------------------\n\n";
interface propsType {
  userState: userState;
  pressInfo: any;
  ableRequest: boolean;
}

interface EditingStates {
  [key: number]: boolean;
}

interface FormListState {
  [key: number]: string;
}

const utils = new CommonUtils();

const ThemeModule = (props: propsType, ref: any) => {
  const toastRef: any = useRef();

  const formNameRef: any = useRef();
  const selectThemeRef: any = useRef();

  const [isLoading, setIsLoading] = useState(false);

  const [selectedThemeInfo, setSelectedThemeInfo] = useState<any>({});

  const [formName, setFormName] = useState("");
  const [formList, setFormList] = useState<any>([]);
  const [formData, setFormData] = useState<any>({});
  const [formExample, setFormExample] = useState<any>({});
  const [formOneShot, setFormOneShot] = useState("");
  const [category, setCategory] = useState("");
  const [themeTitle, setThemeTitle] = useState("");

  useEffect(() => {
    return () => {
      setIsLoading(false);
      setFormName("");
      setFormList([]);
      setFormData({});
      setFormExample({});
      setFormOneShot("");
      setCategory("");
      setThemeTitle("");
    };
  }, []);

  // 테마 선택 팝업 오픈
  const openThemeSelect = () => {
    selectThemeRef.current.open();
  };

  // 부모창에서 테마 내용 조회시 사용
  const getFormData = () => {
    return formData;
  };
  // 부모창에서 샘플테마 내용 조회시 사용
  const getFormExample = () => {
    return formExample;
  };

  // 부모창에서 테마 원샷 데이터 가져오기
  const getformOneShotData = () => {
    return formOneShot;
  };
  const getCategory = () => {
    return category;
  };

  const getThemeTitle = () => {
    return themeTitle;
  };

  // 부모창에서 보도자료 저장시 테마 목록, 내용 조회
  const getThemeInfo = () => {
    return { formList, formData };
  };

  const setThemeInfo = (list: any, data: any) => {
    setFormList([]);
    setFormData({});

    setTimeout(() => {
      setFormData(data);
      setFormList(list);
    }, 300);
  };

  // 테마 항목 추가
  const addFromList = () => {
    if (formName !== "") {
      let newList: any = [...formList, formName];
      setFormName("");
      setFormList(newList);
      const newValue = "";
      const newFormData = {
        ...formData,
        [formName]: newValue,
      };
      setFormData(newFormData);
    }
  };

  // 테마 항목 삭제(메모리상에만 처리 별도 저장 클릭시 DB 저장)
  const removeFormData = (index: number, value: string) => {
    let oldList: any = [...formList];
    oldList.splice(index, 1);
    setFormList(oldList);
    const newData: any = { ...formData };
    delete newData[value];
    setFormData(newData);
  };

  // 작성중인 보도자료 테마 데이터 동기화
  useEffect(() => {
    if (!utils.isEmptyObj(props.pressInfo)) {
      // 보도자료에서 기존에 테마를 지정해서 작업중이면 작업중인 데이터를 세팅한다.
      if (props.pressInfo.form_list?.length > 0) {
        setFormList([]);
        setFormData({});

        setTimeout(() => {
          setFormOneShot(props.pressInfo.one_shot);
          setFormExample(props.pressInfo.form_example);
          setFormData(props.pressInfo.form_data);
          setFormList(props.pressInfo.form_list);
          setCategory(props.pressInfo.category);
          setThemeTitle(props.pressInfo.themeTitle);
        }, 300);
      } else {
        setFormList([]);
        setFormData({});
      }
    }
  }, [props.pressInfo]);

  // 테마 불러오기로 테마 선택시 초기화
  useEffect(() => {
    if (!utils.isEmptyObj(selectedThemeInfo)) {
      setFormList(selectedThemeInfo.form_list);
      setFormData({}); // 입력폼 초기화
      setFormExample(selectedThemeInfo.form_example);
      setFormOneShot(selectedThemeInfo.one_shot);
      setCategory(selectedThemeInfo.category);
      setThemeTitle(selectedThemeInfo.title);
    }
  }, [selectedThemeInfo]);

  // 직전 테마 불러오기
  // const pastePressTheme = () => {
  //   if (formList.length !== 0) {
  //     if (
  //       !window.confirm(
  //         "가장 마지막에 저장된 테마를 불러옵니다.\n계속 진행할까요?"
  //       )
  //     )
  //       return;
  //   }

  //   setFormList([]);
  //   setFormData({});

  //   setTimeout(() => {
  //     setFormData(props.pressInfo.form_data);
  //     setFormList(props.pressInfo.form_list);
  //     setFormExample(props.pressInfo.form_example);
  //     setFormOneShot(props.pressInfo.one_shot);
  //     setCategory(props.pressInfo.category);
  //   }, 300);
  // };

  // 테마 초기화
  const resetTheme = () => {
    if (!window.confirm("불러온 테마를 삭제합니다.\n계속 진행할까요?")) return;
    setFormList([]);
    setFormData({});
  };

  // 테스트 데이터 넣기
  const insertExample = () => {
    setFormData(formExample);
  };

  // 부모 Component에서 접근 가능하도록 함수 전달.
  useImperativeHandle(ref, () => ({
    getFormData,
    getThemeInfo,
    setThemeInfo,
    getformOneShotData,
    getFormExample,
    getCategory,
    getThemeTitle,
  }));

  // 데이터 항목 제목 바꾸기 : 각 항목의 편집 상태를 관리하는 객체 초기화
  const [editingStates, setEditingStates] = useState<EditingStates>({});
  const [editResults, setEditResults] = useState<FormListState>(
    formList.reduce((acc: any, currentValue: any, index: any) => {
      acc[index] = currentValue;
      return acc;
    }, {})
  );
  // 항목을 더블 클릭할 때 호출될 함수
  const handleDtDoubleClick = (index: number) => {
    setEditingStates({
      ...editingStates,
      [index]: true,
    });
  };

  // 편집을 마칠 때 호출될 함수
  //1.기존 키를 가져와서 삭제하고
  //2.새로운 키를 넣어서 FormData를 새로 만들어야함
  const handleFinishEditing = (index: number) => {
    const originalKey = formList[index]; // 원래의 키값
    let newKey = editResults[index]; // 수정된 새로운 키값
    if (newKey === undefined) {
      newKey = originalKey;
    }
    if (newKey !== undefined) {
      const newValue = formData[originalKey]; // 원래 키에 연결된 값 가져오기
      const { [originalKey]: removed, ...restFormData } = formData; //삭제

      const newFormData = {
        ...restFormData,
        [newKey]: newValue, // 새로운 키와 원래의 값 추가
      };
      setFormData(newFormData);

      // formList 업데이트
      const newFormList = [...formList];
      newFormList[index] = newKey;
      setFormList(newFormList);

      // 편집 상태 종료를 위한 새로운 editingStates 설정
      const newEditingStates = {
        ...editingStates,
        [index]: false, // 해당 인덱스의 편집 상태를 false로 설정
      };
      setEditingStates(newEditingStates);
    }
  };
  // 스타일 객체를 각 항목의 편집 상태에 따라 동적으로 반환하는 함수
  const getDtStyle = (isEditing: boolean) => ({
    cursor: "pointer",
    display: isEditing ? "none" : "",
  });

  return (
    <>
      <Box>
        {/* 테마 선택 버튼 영역 (가로 배치)*/}
        {props.pressInfo.press_status !== "COMPLETE" && (
          <div className="set-theme-wrap flex justify-content-sb">
            <div className="theme-wrap">
              {/* {props.pressInfo.form_list?.length > 0 && (
                <button
                  className="load-theme btn-ghost"
                  disabled={
                    !props.ableRequest ||
                    (!(
                      props.pressInfo.press_status === "CREATE" ||
                      props.pressInfo.press_status === "REJECTED"
                    ) &&
                      !(
                        props.userState.isAdmin &&
                        props.userState.id === props.pressInfo.hongbo_user_id
                      ))
                  }
                  onClick={pastePressTheme}
                >
                  <img src="/images/icon-load-theme.png" />
                  <span>직전테마 불러오기</span>
                </button>
              )} */}
              <button
                className="load-theme btn-ghost"
                onClick={openThemeSelect}
                disabled={
                  !props.ableRequest ||
                  (!(
                    props.pressInfo.press_status === "CREATE" ||
                    props.pressInfo.press_status === "RETURNED" ||
                    props.pressInfo.press_status === "REJECTED"
                  ) &&
                    !(
                      props.userState.isAdmin &&
                      props.userState.id === props.pressInfo.hongbo_user_id
                    ))
                }
              >
                <img src="/images/icon-select-theme.png" />
                <span>테마선택</span>
              </button>
              <button
                className="select-theme btn-ghost"
                onClick={resetTheme}
                disabled={
                  !props.ableRequest ||
                  (!(
                    props.pressInfo.press_status === "CREATE" ||
                    props.pressInfo.press_status === "RETURNED" ||
                    props.pressInfo.press_status === "REJECTED"
                  ) &&
                    !(
                      props.userState.isAdmin &&
                      props.userState.id === props.pressInfo.hongbo_user_id
                    ))
                }
              >
                <img src="/images/icon-refresh.png" />
                <span>초기화</span>
              </button>
            </div>

            {(props.userState.isSuperAdmin ||
              props.userState.id === "bluegury@gmail.com") && (
              <button className="refresh btn-text" onClick={insertExample}>
                <BorderColorIcon />
              </button>
            )}
          </div>
        )}
      </Box>
      {/* 테마 항목 추가 영역 */}
      {props.pressInfo.press_status !== "COMPLETE" && (
        <div className="inputbox-wrap">
          <div className="add-data">
            <input
              type="text"
              placeholder="추가할 데이터 항목을 입력해주세요"
              ref={formNameRef}
              value={formName}
              onChange={(e) => {
                if (
                  props.pressInfo.press_status === "CREATE" ||
                  props.pressInfo.press_status === "RETURNED" ||
                  props.pressInfo.press_status === "REJECTED" ||
                  (props.userState.isAdmin &&
                    props.userState.id === props.pressInfo.hongbo_user_id)
                )
                  setFormName(e.target.value);
              }}
              onKeyDown={(e) => {
                if (
                  e.key === "Enter" &&
                  !e.nativeEvent.isComposing &&
                  (props.pressInfo.press_status === "CREATE" ||
                    props.pressInfo.press_status === "RETURNED" ||
                    props.pressInfo.press_status === "REJECTED" ||
                    (props.userState.isAdmin &&
                      props.userState.id === props.pressInfo.hongbo_user_id))
                )
                  addFromList();
              }}
            />
            <button
              onClick={addFromList}
              disabled={
                !props.ableRequest ||
                (!(
                  props.pressInfo.press_status === "CREATE" ||
                  props.pressInfo.press_status === "RETURNED" ||
                  props.pressInfo.press_status === "REJECTED"
                ) &&
                  !(
                    props.userState.isAdmin &&
                    props.userState.id === props.pressInfo.hongbo_user_id
                  ))
              }
            >
              추가
            </button>
          </div>
        </div>
      )}

      {/* 테마 상세 영역 */}
      <div className="inputbox-wrap">
        <div className="data-wrap">
          {formList.map((value: string, index: number) => (
            <dl className="inputbox" key={`formData-${index}`}>
              {editingStates[index] ? (
                <TextField
                  autoFocus
                  size="small"
                  value={editResults[index] ?? value}
                  onBlur={() => handleFinishEditing(index)}
                  onChange={(e) => {
                    const newEditResults = {
                      ...editResults,
                      [index]: e.target.value,
                    };
                    setEditResults(newEditResults);
                  }}
                />
              ) : (
                <dt
                  style={getDtStyle(editingStates[index])}
                  onDoubleClick={() => {
                    if (
                      props.pressInfo.press_status === "CREATE" ||
                      props.pressInfo.press_status === "RETURNED" ||
                      props.pressInfo.press_status === "REJECTED" ||
                      (props.userState.isAdmin &&
                        props.userState.id === props.pressInfo.hongbo_user_id)
                    ) {
                      handleDtDoubleClick(index);
                    }
                  }}
                >
                  {value}
                </dt>
              )}
              <dd>
                <TextField
                  variant="standard"
                  InputProps={{
                    disableUnderline: true,
                  }}
                  multiline
                  fullWidth
                  size="small"
                  id="resizableTextarea"
                  placeholder={
                    utils.isEmptyObj(formExample)
                      ? "내용을 입력하세요."
                      : formExample[value]
                  }
                  value={utils.isEmptyObj(formData) ? "" : formData[value]}
                  onChange={(e) => {
                    if (
                      props.pressInfo.press_status === "CREATE" ||
                      props.pressInfo.press_status === "RETURNED" ||
                      props.pressInfo.press_status === "REJECTED" ||
                      (props.userState.isAdmin &&
                        props.userState.id === props.pressInfo.hongbo_user_id)
                    ) {
                      const newData: any = { [value]: e.target.value };
                      setFormData({ ...formData, ...newData });
                    }
                  }}
                />
              </dd>
              <dd className="flex">
                <button
                  className="del-data"
                  title="항목삭제"
                  onClick={() => {
                    if (
                      props.pressInfo.press_status === "CREATE" ||
                      props.pressInfo.press_status === "RETURNED" ||
                      props.pressInfo.press_status === "REJECTED" ||
                      props.userState.isAdmin
                    )
                      removeFormData(index, value);
                  }}
                  disabled={
                    !props.ableRequest ||
                    (!(
                      props.pressInfo.press_status === "CREATE" ||
                      props.pressInfo.press_status === "RETURNED" ||
                      props.pressInfo.press_status === "REJECTED"
                    ) &&
                      !(
                        props.userState.isAdmin &&
                        props.userState.id === props.pressInfo.hongbo_user_id
                      ))
                  }
                />
              </dd>
            </dl>
          ))}
        </div>
      </div>
      {/* 불러온 one shot 확인 */}
      {/* <Box>
        <TextField
          size="small"
          fullWidth
          multiline
          rows={10}
          placeholder={"예시를 입력하세요."}
          value={formOneShot}
          type="search"
          autoComplete="off"
          inputProps={{ enterKeyHint: "enter" }}
        />
      </Box> */}
      {/* 테마 불러오기 팝업 */}
      <PopThemeSelect
        ref={selectThemeRef}
        userState={props.userState}
        selectTheme={(theme: any) => {
          setSelectedThemeInfo(theme);
        }}
      />
      {/* 로딩 써클 */}
      <LoadingCircle loading={isLoading} />
      {/* 토스트 */}
      <Toast ref={toastRef} />
    </>
  );
};

export default forwardRef(ThemeModule);
